import styled from 'styled-components';
import { Card } from 'antd';
import { colors } from '../../theme';
import { tileConfig, boardConfig } from './config';

export const ChimpTestBox = styled.div`
    display: flex;
    flex: 1;
    position: relative;
    border-radius: 4px;
    padding: 3px;
    background: #000;
    flex-direction: column;
    width: ${boardConfig.width + 6}px;
    height: ${boardConfig.height + 6 + 34}px;
`;

export const ChipTextInfoHeader = styled.div`
    color: #FFF;
    padding: 2px;
    font-size: 17px;
    display: flex;
    justify-content: space-between;
`;

export const GameBoard = styled.div`
    display: flex;
    width: ${boardConfig.width}px;
    height: ${boardConfig.height}px;
    background: #999;
    border-radius: 4px;
    position: relative;
`;

export const StartButtonBox = styled.div`
    position: absolute;
    display: flex;
    flex: 1;
    /* width: ${boardConfig.width}px;
    height: ${boardConfig.height}px; */
    top: 3px; bottom: 3px;
    left: 3px; right: 3px;
    justify-content: center;
    align-items: center;
    z-index: 99;
    background: #222;
`;

export const SingleTile = styled(Card)<{ x: number, y: number, hid: boolean, visib: boolean }>`
    position: absolute;
    top: ${props => props.x}px;
    left: ${props => props.y}px;
    width: ${tileConfig.width}px;
    height: ${tileConfig.height}px;
    background: ${props => props.hid ? colors.green : '#fff'};
    ${props => !props.hid && `border: 5px solid #ddd;`}
    border-radius: 4px;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    cursor: pointer;
    ${props => props.visib ? `display: flex;` : `display: none`};
`;

export const GameOverBox = styled.div`
    position: absolute;
    top: 0; left: 0;
    width: ${boardConfig.width}px;
    height: ${boardConfig.height}px;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
    background: #999;
    border-radius: 4px;
    flex-direction: column;
`;

export const GameOverInfo = styled(Card)`
    background: ${colors.red};
`;

export const GameOverInfoText = styled.div`
    color: #fff;
    text-align: center;
    margin-bottom: 10px;
`;
